<template>
    <v-layout justify-center>
        <v-responsive max-width="640" width="100%" height="100%" class="px-3 mx-n3">
            <list-heading title="트렌드 보고서 목록">
                <template #buttons>
                    <recruitment-report-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn rounded color="secondary" v-bind="attrs" v-on="on">
                                <v-icon small class="mr-1">mdi-file-chart</v-icon>
                                수동 보고서 생성
                            </v-btn>
                        </template>
                    </recruitment-report-form>
                </template>
            </list-heading>

            <v-data-table v-bind="{ loading, headers, items }" item-key="_id" itemid="_id" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" single-expand style="overflow: hidden" @click:row="onClickRow">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn x-small text fab tile @click.capture.stop="remove(item)"> <v-icon>mdi-delete</v-icon> </v-btn>
                </template>
            </v-data-table>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="mt-2" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch__console } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import RecruitmentReportForm from "@/components/console/recruitment/report/recruitment-report-form.vue";

export default {
    components: {
        ListHeading,
        RecruitmentReportForm,
    },
    data: () => ({
        reports: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,
        attrs_switch__console,
    }),
    computed: {
        items() {
            return [...this.reports];
        },
        headers() {
            return [
                {
                    width: +60,
                    text: "#",
                    value: "index",
                    align: "end",
                },
                {
                    text: "제목",
                    value: "subject",
                    cellClass: "text-truncate max-width-0",
                },
                {
                    width: 100,
                    text: "생성일시",
                    value: "createdAt",
                    formatter: (value) => value?.toDateTime?.(),
                },
                {
                    width: +64,
                    text: "",
                    value: "actions",
                },
            ].map((item, index, array) => ({ ...item, divider: index != array.length - 1, cellClass: (item.cellClass || "") + " caption", formatter: item.formatter ?? ((value) => value ?? "-") }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, reports } = await api.console.recruitments.reports.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.reports = reports.map((item, index) => ({ index: summary.totalCount - (this.page - 1) * this.limit - index, ...item }));
            } finally {
                this.loading = false;
            }
        },

        async update(report) {
            if (this.loading) return;
            else this.loading = true;

            try {
                report = (await api.console.recruitments.reports.put(report))?.report;
                this.updateItem(report);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        async remove(report) {
            const go = confirm(`"${report?.subject}" 항목을 삭제하시겠습니까?`);
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                [{ report }] = [await api.console.recruitments.reports.delete({ _id: report._id })];
                this.reports = this.reports.filter(({ _id }) => _id !== report._id);
                alert(`"${report?.subject}" 항목이 삭제되었습니다.`);
                this.summary.totalCount -= 1;
            } finally {
                this.loading = false;
                this.search();
            }
        },

        updateItem(report) {
            const index = this.reports.findIndex(({ _id }) => _id == report._id);
            if (0 <= index) this.reports.splice(index, 1, report);
            else {
                this.reports = [report, ...this.reports];
                this.summary.totalCount += 1;
            }
            this.search();
        },

        onClickRow(item) {
            let newWindow = window.open("", "_blank", `toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=1,resizable=0,width=713,height=${screen.height},top=0,left=0`);
            newWindow.document.write(item.stylizing.result);
            newWindow.moveTo(0, 0);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }

    tbody > tr:not(.v-data-table__expanded__content) {
        cursor: pointer;
    }
}
</style>
